import { Box } from '@mui/material';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import { vehiclePageStyles } from '../../styles';

interface PictureActionsProps {
  selectedCount: number;
  allSelected: boolean;
  isSelectedAlreadyCover: boolean;
  onAddPictures: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectAll: () => void;
  onSetAsCover: () => void;
  onDelete: () => void;
}

export const PictureActions: React.FC<PictureActionsProps> = ({
  selectedCount,
  allSelected,
  isSelectedAlreadyCover,
  onAddPictures,
  onSelectAll,
  onSetAsCover,
  onDelete,
}) => {
  return (
    <Box sx={vehiclePageStyles.picturesFooter}>
      <ActionButton inRow type="add" component="label" iconSize="medium">
        Add
        <input type="file" accept="image/png, image/jpg, image/jpeg" multiple hidden onInput={onAddPictures} />
      </ActionButton>
      <ActionButton inRow type="selectAll" iconSize="medium" onClick={onSelectAll} disabled={allSelected}>
        SELECT ALL
      </ActionButton>
      <ActionButton
        inRow
        type="image"
        iconSize="medium"
        onClick={onSetAsCover}
        disabled={selectedCount !== 1 || isSelectedAlreadyCover}
      >
        SET AS COVER
      </ActionButton>
      <ActionButton inRow type="delete" iconSize="medium" onClick={onDelete} disabled={selectedCount === 0}>
        DELETE
      </ActionButton>
    </Box>
  );
};
